module.exports = __webpack_public_path__ + "img/public/AdminIcons/manageCurrency.svg?843be9de";